// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.feed-wrapper[data-v-083aebab] {
  width: 100%;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
.feed-scroll[data-v-083aebab] {
  flex: 1;
  overflow-y: auto;
}
.feed-scroll.reversed[data-v-083aebab] {
  display: flex;
  flex-direction: column-reverse;
}`, "",{"version":3,"sources":["webpack://./src/SharedWeb/scripts/dynamic-components/render-engine/components/production/elements/dynamic-app-elements/display/DynamicAppFeedElement.vue","webpack://./DynamicAppFeedElement.vue"],"names":[],"mappings":"AAEA;EACE,WAAA;EACA,OAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;ACDF;ADIA;EACE,OAAA;EACA,gBAAA;ACDF;ADIA;EACE,aAAA;EACA,8BAAA;ACDF","sourcesContent":["@import \"@/styles/breakpoint-mixin.scss\";\n\n.feed-wrapper {\n  width: 100%;\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.feed-scroll {\n  flex: 1;\n  overflow-y: auto;\n}\n\n.feed-scroll.reversed {\n  display: flex;\n  flex-direction: column-reverse;\n}\n",".feed-wrapper {\n  width: 100%;\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.feed-scroll {\n  flex: 1;\n  overflow-y: auto;\n}\n\n.feed-scroll.reversed {\n  display: flex;\n  flex-direction: column-reverse;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
